module.exports = __webpack_public_path__ + "static/img/dd-banner-04.68621e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-banner-04.png
// module id = duXk
// module chunks = 1